const allBines = [
  553650,
  414075,
  414089,
  414791,
  511578,
  414068,
  491914,
  512409,
  549825,
  414064,
  491911,
  512312,
  491910,
  491909,
  491931,
  404208,
  404293,
  455103,
  438168,
  455170,
];

export const specialBines = [519348, 512409];

const bines = allBines.concat(specialBines);

export default bines;
